'use client'

import Button from '@shared/components/Button/Button'
import { BookMarked as LawIcon } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@shared/components/Tooltip/Tooltip'
import { theme } from '@/styles/theme.css'

/**
 * Tooltip-wrapped "jump to law" link rendered above the clause heading.
 * Client-only by design — Server Components can't pass JSX through Ariakit's
 * `render` prop reliably (intermittent "render is not a function" in
 * TooltipAnchor).
 *
 * Avoids `render={<Button />}` entirely too: the Button sits as a regular
 * child of TooltipTrigger, so we don't compose Tooltip's render with
 * Button's own internal `BaseButton render={(props) => <Link />}`. The
 * extra wrapping anchor `<div>` is acceptable; chained render-prop elements
 * intermittently resolved to `undefined` during reconciliation.
 */
export function JumpToLawButton({
  href,
  abbreviation,
  title,
}: {
  href: string
  abbreviation: string | null
  title: string | null
}) {
  return (
    <Tooltip placement='bottom-start'>
      <TooltipTrigger>
        <Button
          href={href}
          variant='flat'
          size='small'
          style={{
            marginLeft: -9,
            marginBottom: -9,
            fontWeight: 600,
            color: theme.colors.text.brand,
            cursor: 'default',
          }}
        >
          <LawIcon width={16} />
          <span>{abbreviation}</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent style={{ textAlign: 'left' }}>
        <b>{title}</b>
        <br />
        <i style={{ color: theme.colors.text.tertiary }}>Zum Gesetz springen</i>
      </TooltipContent>
    </Tooltip>
  )
}
